function closePopover() {
  const target = this.getAttribute("target")

  const popoverElement = document.querySelector(`[popover][data-target="${target}"]`)

  if (popoverElement) {
    popoverElement.hidePopover()
  }
}

export function activate(Turbo) {
  Turbo.StreamActions.close_popover = closePopover
}
